<template>
  <div>
    <breadcrumb :routerList="[{to:'/salesPromotionList',title:'促销活动管理'},{ title:'创建促销活动'}]" v-if="addOrUpdate==='add'"/>
    <breadcrumb :routerList="[{to:'/salesPromotionList',title:'促销活动管理'},{ title:'修改促销活动'}]" v-if="addOrUpdate==='update'"/>
    <div class="h-piece" style="margin:20px">
      <!-- 活动信息 -->
      <div class="h-pieceIn2 n-xiao">
        <div class="h-pieceTitle2 " style="margin-left:10px">
          <h1>活动信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine">
            <el-form ref="ruleForms" :model="order" :rules="ruleForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item label="活动名称" class="h-elformWrap-2" prop="activityName">
                <el-input v-model="order.activityName" placeholder="请输入活动名称" />
              </el-form-item>
              <el-form-item label="活动描述" class="h-elformWrap-2">
                <el-input v-model="order.activityDescription" placeholder="请输入活动描述" />
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="order.createUser" readonly />
              </el-form-item>
              <el-form-item label="销售公司" class="h-elformWrap-2" prop="saleGroupCode">
                <brselect category="xiaoshou_zuzhi"
                          :v="order.saleGroupCode"
                          @change="saleChange"
                          :showcode="true" v-model="order.saleGroupCode" clearable/>
              </el-form-item>
              <el-form-item label="活动开始日期" class="h-elformWrap-2" prop="startTime">
                <el-date-picker
                    :clearable="false"
                    type="datetime"
                    placeholder="选择开始时间"
                    v-model="order.startTime"
                    :picker-options="pickerOptions"
                    @change="handleStartDateChange"
                    format="yyyy-MM-dd HH:mm:ss"
                    clearable
                />
              </el-form-item>
              <el-form-item label="活动结束日期" class="h-elformWrap-2" prop="endTime">
                <el-date-picker
                    :clearable="false"
                    type="datetime"
                    placeholder="选择结束时间"
                    v-model="order.endTime"
                    :picker-options="pickerOptions"
                    @change="handleEndDateChange"
                    format="yyyy-MM-dd HH:mm:ss"
                    clearable
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <!-- 产品信息 -->
      <div class="h-pieceIn2 n-xiao">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>产品信息</h1>
          <el-button
              size="small"
              type="primary"
              icon="el-icon-circle-plus"
              style="margin-left: 50px;"
              @click="showProductDialog"
          >
            选择产品
          </el-button>
        </div>

        <!-- 产品列表 -->
        <div v-if="productData.length > 0">
          <div v-for="(product, productIndex) in productData" :key="productIndex" class="product-item" style="margin-bottom: 10px;">
            <!-- 产品信息表格 -->
            <el-table :data="[product]" stripe border style="width: 70%">
              <el-table-column prop="productCode" label="产品编码" :show-overflow-tooltip="true" width="95"></el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="产品名称" min-width="120"></el-table-column>
              <el-table-column prop="specificationModel" :show-overflow-tooltip="true" label="规格型号" min-width="120"> </el-table-column>
              <el-table-column prop="quantity" :show-overflow-tooltip="true" label="数量" min-width="100">
                <template slot-scope="scope">
                  <el-input
                      v-model.number="scope.row.quantity"
                      @input="handleNumInput(scope)"
                      placeholder="请输入正整数"
                  />
                </template>
              </el-table-column>
<!--              <el-table-column prop="promotionPrice" label="基准价" :show-overflow-tooltip="true" width="90"></el-table-column>-->
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button type="text" @click="showGiftDialog(product)">添加赠品</el-button>
                  <el-button type="text" @click="deleteProduct(productIndex)" style="color: #f56c6c;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 赠品信息表格 -->
            <el-table
                :data="product.giftsList"
                stripe
                border
                style="width: 30%"
            >
              <el-table-column prop="productCode" label="赠品编码" :show-overflow-tooltip="true" min-width="95"></el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="赠品名称" min-width="120"></el-table-column>
              <el-table-column prop="quantity" :show-overflow-tooltip="true" label="赠品数量" width="90">
                <template slot-scope="scope">
                  <el-input
                      v-model.number="scope.row.quantity"
                      @input="handleNumInput(scope)"
                      placeholder="请输入正整数"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="deleteGift(product.giftsList, scope.$index)"
                      style="color: #f56c6c;"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 无产品提示 -->
        <div v-else class="no-product" style="text-align: center; padding: 20px; color: #999;">
          暂无产品，请点击"选择产品"按钮添加
        </div>
      </div>
    </div>

    <div>
      <div class="anniu">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backToList">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit('submit')" v-if="addOrUpdate==='add'">确认提交</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="handleUpdate()" v-else>确认修改</el-button>
        </el-row>
      </div>
    </div>

    <!-- 产品选择对话框 -->
    <product-list
        :visible.sync="showProductDialogVisible"
        :title="'选择产品'"
        :sale-group-code="order.saleGroupCode"
        :multiple="true"
        @select="handleProductSelect"
        @close="handleDialogClose"
    />

    <!-- 赠品选择对话框 -->
    <product-list
        ref="giftList"
        :visible.sync="showGiftDialogVisible"
        :title="'选择赠品'"
        :sale-group-code="order.saleGroupCode"
        :multiple="true"
        @select="handleGiftSelect"
        @close="handleGiftClose"
    />

  </div>
</template>
<script>
import salesPromotion from "@/api/salesPromotion";
import productList from "./productModel.vue";
import moment from "moment";
export default {
  components: { productList },
  data() {
    return {
      // 活动基本信息
      order: {
        activityName: '',        // 活动名称
        startTime: null,         // 开始时间
        endTime: null,           // 结束时间
        activityDescription: '', // 活动描述
        createUser: '',          // 创建人姓名
        createUserCode: '',      // 创建人编码
        saleGroup: '',           // 销售公司
        saleGroupCode: '',       // 销售公司编码
        currencyCode: '',
        customerChannelCode: '',
        salesregion: '',
      },
      ruleForm: {
        activityName: [{required: true, message: '请填写活动名称', trigger: 'blur'}],
        saleGroupCode: [{required: true, message: '请选择销售公司', trigger: 'blur'}],
        startTime: [{required: true, message: '请填写活动开始时间', trigger: 'blur'}],
        endTime: [{required: true, message: '请填写活动结束时间', trigger: 'blur'}],
      },
      // 产品数据列表
      productData: [],
      // 对话框控制
      showProductDialogVisible: false,
      selectList: [],
      showGiftDialogVisible: false,
      // 当前操作的产品（用于赠品关联）
      currentProduct: '',
      // 其他参数
      ddlx: '',
      xmcode: '',
      // 操作类型（新增/修改）
      addOrUpdate: 'add',
      currentUser: null,
      // 限制收货时间不让选择今天以前的
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      q:{
        saleGroupCode: '',
        productDesc: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      ttdata: [],//产品列表
    };
  },
  methods: {
    // 处理对话框关闭
    handleDialogClose() {
      // 对话框关闭后的逻辑
      this.showProductDialogVisible = false
    },
    // 显示产品选择对话框
    showProductDialog() {
      if(this.order.saleGroupCode){
        this.showProductDialogVisible = true;
      }else{
        this.$message.warning('请先选择销售公司')
      }
    },
    // 处理产品选择结果
    handleProductSelect(selectedProducts) {
      this.showProductDialogVisible = false
      if (!selectedProducts || !selectedProducts.length) return;
      // 处理选择的产品，补充必要字段
      const newProducts = selectedProducts.map(product => ({
        productCode: product.productCode || '',
        productName: product.productName || '',
        specificationModel: product.specificationModel || '', // 规格型号
        quantity: product.quantity || 1,          // 数量默认1
        giftsList: []                    // 赠品列表初始化
      }))
      // 合并产品（避免重复添加）
      const uniqueNewProducts = newProducts.filter(newItem => {
        // 检查新项是否已存在于原有数据中
        return !this.productData.some(existingItem =>
            existingItem.productCode === newItem.productCode
        );
      });
      // 合并去重后的新数据
      this.productData = [...this.productData, ...uniqueNewProducts]
    },
    // 显示赠品选择对话框
    showGiftDialog(product) {
      this.currentProduct = product;
      this.showGiftDialogVisible = true;
      if (this.$refs.giftList && this.$refs.giftList.queryParams.productCodeNameLike) {
        this.$refs.giftList.resetSearch();
      }
    },
    // 处理赠品选择结果
    handleGiftSelect(selectedGifts) {
      this.showGiftDialogVisible = false;
      if (!this.currentProduct || !selectedGifts || !selectedGifts.length) return;
      // // 处理选择的赠品，补充必要字段
      const newGifts = selectedGifts.map(gift => ({
        productCode: gift.productCode || '',
        productName: gift.productName || '',
        quantity: gift.quantity || 1 // 赠品数量默认1
      }));
      // 合并产品（避免重复添加）
      const uniqueNewProducts = newGifts.filter(newItem => {
        // 检查新项是否已存在于原有数据中
        return !this.currentProduct.giftsList.some(existingItem =>
            existingItem.productCode === newItem.productCode
        );
      });
      // 添加到当前产品的赠品列表
      this.currentProduct.giftsList = [...this.currentProduct.giftsList, ...uniqueNewProducts];
      // 清空当前产品引用t==
      this.currentProduct = null;
    },
    //关闭赠品
    handleGiftClose(){
      this.showGiftDialogVisible = false;
    },
    // 删除产品
    deleteProduct(index) {
      this.$confirm('确定要删除该产品及关联的赠品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.productData.splice(index, 1);
        this.$message.success('删除成功');
      }).catch(() => {
        // 取消删除
      });
    },
    // 删除赠品
    deleteGift(giftList, index) {
      this.$confirm('确定要删除该赠品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        giftList.splice(index, 1);
        this.$message.success('删除成功');
      }).catch(() => {
        // 取消删除
      });
    },
    // 处理数量输入（确保为正整数）
    handleNumInput(scope) {
      // 只保留数字
      const value = String(scope.row.quantity).replace(/[^\d]/g, '');
      // 转换为数字
      const quantity = parseInt(value, 10) || 0;
      // 确保大于0
      scope.row.quantity = quantity > 0 ? quantity : 0;
    },
    // 处理开始日期变更
    handleStartDateChange() {
      // 如果开始日期晚于结束日期，清空结束日期
      if (this.order.startTime && this.order.endTime) {
        const start = new Date(this.order.startTime);
        const end = new Date(this.order.endTime);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        if (start > end) {
          this.order.endTime = null;
          this.$message.warning('开始日期不能晚于结束日期，已清空结束日期');
        }
      }
      if(this.order.startTime) {
        this.order.startTime = moment(this.order.startTime).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    // 处理结束日期变更
    handleEndDateChange() {
      // 如果结束日期早于开始日期，清空开始日期
      if (this.order.startTime && this.order.endTime) {
        const start = new Date(this.order.startTime);
        const end = new Date(this.order.endTime);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        if (end < start) {
          this.order.startTime = null;
          this.$message.warning('结束日期不能早于开始日期，已清空开始日期');
        }
      }
      if(this.order.endTime) {
        this.order.endTime = moment(this.order.endTime).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    // 返回列表页
    backToList() {
      this.$router.go(-1);
    },
    //销售组织
    saleChange(obj){
      this.order.saleGroup = obj.name
      this.order.saleGroupCode = obj.code
    },
    // 保存或提交
    saveOrSubmit() {
      // 基础校验
      if (this.productData.length === 0) {
        this.$message.error('请至少添加一个产品');
        return;
      }
      this.$refs.ruleForms.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.order,
            productsList: this.productData
          };
          salesPromotion.saveActivities(submitData).then(res=>{
            if(res.f){
              this.$router.push({path: "/salesPromotionList"});
            }
          })
        }
      })
    },
    //获取详情
    getDetail(id){
      salesPromotion.selectActivityById(id).then(res=>{
        if(res.f){
          this.order= res.obj;
          this.productData = res.obj.productsList
        }
      })
    },
    //修改
    handleUpdate(){
      // 基础校验
      if (this.productData.length === 0) {
        this.$message.error('请至少添加一个产品');
        return;
      }
      this.$refs.ruleForms.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.order,
            productsList: this.productData
          };
          salesPromotion.updateActivities(submitData).then(res=>{
            if(res.f){
              this.$router.push({path: "/salesPromotionList"});
            }
          })
        }
      })
    },
  },
  mounted() {
    this.addOrUpdate = this.$route.query.type || 'add';
    let id = this.$route.query.id;
    if(this.addOrUpdate === 'update' && id){
      this.getDetail(id);
    }
    // 初始化创建人（实际项目中可能从登录信息获取）
    // this.order.createBy = '当前登录用户';
  },
  created() {
    this.order.createUserCode = this._user.usercode;
    this.order.createUser = this._user.username;
  }
};
</script>
<style scoped>
/* 保持原有样式并补充 */
.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.product-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.no-product {
  border: 1px dashed #ccc;
  border-radius: 4px;
  margin-top: 10px;
}

/* 按钮样式补充 */
::v-deep .el-button--text {
  padding: 0 5px;
}
.h-formbLine .h-elformWrap-2{
  width: 33.3%
}
</style>
